import { TypedSopNode } from "./_Base";
import { NodeParamsConfig, ParamConfig } from "../utils/params/ParamsConfig";
import { NodeContext } from "../../poly/NodeContext";
import { InputCloneMode } from "../../poly/InputCloneMode";
import { isBooleanTrue } from "../../../core/Type";
class ActorSopParamsConfig extends NodeParamsConfig {
  constructor() {
    super(...arguments);
    this.useThisNode = ParamConfig.BOOLEAN(1);
    this.node = ParamConfig.NODE_PATH("", {
      visibleIf: { useThisNode: 0 },
      dependentOnFoundNode: false
    });
  }
}
const ParamsConfig = new ActorSopParamsConfig();
export class ActorSopNode extends TypedSopNode {
  constructor() {
    super(...arguments);
    this.paramsConfig = ParamsConfig;
    this._childrenControllerContext = NodeContext.ACTOR;
  }
  static type() {
    return "actor";
  }
  initializeNode() {
    this.io.inputs.setCount(1);
    this.io.inputs.initInputsClonedState(InputCloneMode.FROM_NODE);
  }
  async cook(inputCoreGroups) {
    const coreGroup = inputCoreGroups[0];
    const objects = coreGroup.objects();
    const actorNode = this._findActorNode();
    if (actorNode) {
      for (let object of objects) {
        this.scene().actorsManager.assignActorBuilder(object, actorNode);
      }
    }
    this.setCoreGroup(coreGroup);
  }
  _findActorNode() {
    if (isBooleanTrue(this.pv.useThisNode)) {
      return this;
    } else {
      return this.pv.node.node();
    }
  }
  createNode(node_class, options) {
    return super.createNode(node_class, options);
  }
  children() {
    return super.children();
  }
  nodesByType(type) {
    return super.nodesByType(type);
  }
  childrenAllowed() {
    return true;
  }
}
